import { render } from "./BannerComp.vue?vue&type=template&id=29c1cc2d&scoped=true"
import script from "./BannerComp.vue?vue&type=script&lang=js"
export * from "./BannerComp.vue?vue&type=script&lang=js"

import "./BannerComp.vue?vue&type=style&index=0&id=29c1cc2d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c1cc2d"]])

export default __exports__